// API URL resolution. Reads VITE_API_URL from the build env — that's
// the only source of truth now.
//
// The previous version supported a per-machine localStorage override
// (set in Settings → Desktop) so a desktop could point at an
// alternate API host. Removed 2026-05 because:
//   - production has a single canonical hostname (api.hammerly.app),
//   - lookups had a comma-list bug that the override mechanism made
//     harder to debug,
//   - and the override allowed individual machines to drift off the
//     workspace-wide configuration the rest of the team uses.
//
// If a future use case actually needs per-machine targeting (LAN-
// hosted dev API, etc.), add it back with a clearer UX — e.g.
// require a `?api=…` flag rather than persisting silently.

export function resolveApiBaseUrl(): string {
  const envUrl = import.meta.env.VITE_API_URL as string | undefined;
  if (!envUrl) {
    throw new Error(
      "VITE_API_URL is not set. The web build must be produced with " +
        "VITE_API_URL pointing at the API origin (e.g. https://api.hammerly.app).",
    );
  }
  return envUrl.trim().replace(/\/+$/, "");
}
